<div class="filter-for-list"  *ngIf="isChipView && chipViews?.length > 0">
  <br clear="both"/>
  <div class="chip-view-list">
    <div style="float:left;line-height:30px;font-size:11px">{{'PROJECTS_MENU_VIEWS'|translate}} :</div>
    <mat-chip-list>
      <mat-chip class="chipView"
                *ngFor="let view of chipViews index as i "
                (click)="goToView(view.id)"
                [ngbTooltip]="'CHART_TOOLTIP'|translate">
        {{view.viewName}}
        <fa-icon *ngIf="view.featured" [icon]="faStar" style="color:orange"></fa-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
  <br clear="both"/>
</div>

<div *ngIf="!isChipView">
  <div *ngIf="isModal" class="modal-header">
    <h4 class="modal-title"
        [innerHtml]="('PROJECTS_MENU_VIEWS'|translate)"></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="filter-for-list">
    <h3 *ngIf="!isModal" class="alarm-project-name" [innerHtml]="('PROJECTS_MENU_VIEWS'|translate)"></h3>
    <app-project-sub-menu *ngIf="!isModal"></app-project-sub-menu>
    <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
      <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
    </mat-form-field>
    <br clear="both"/>
  </div>
  <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
  <table mat-table [dataSource]="views" matSort class="table-striped" style="width:100%">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
      <td mat-cell *matCellDef="let view"> {{view.id}}</td>
    </ng-container>
    <ng-container matColumnDef="viewName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
      <td mat-cell *matCellDef="let view"><b>{{view.viewName}}</b>
      </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DESCRIPTION'|translate}}</th>
      <td mat-cell *matCellDef="let view"><b>{{view.description}}</b>
      </td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DATE'|translate}}</th>
      <td mat-cell *matCellDef="let view"><b>{{view.updatedAt | date:'M/d/yyyy, h:mm a'}}</b>
      </td>
    </ng-container>
    <ng-container matColumnDef="featured">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'FEATURED'|translate}}</th>
      <td mat-cell *matCellDef="let view"><b>
        <fa-icon *ngIf="view.featured" [icon]="faStar" style="color:orange"></fa-icon>
      </b>
      </td>
    </ng-container>
    <ng-container matColumnDef="action1">
      <th mat-header-cell *matHeaderCellDef>{{'TOOL_MENU_VIEWS'|translate}}</th>
      <td mat-cell *matCellDef="let view">
        <mat-icon style="color:blue;cursor:pointer" (click)="goToView(view.id)"
                  matTooltipPosition="right"
                  [matTooltip]="'TOOL_MENU_VIEWS'|translate">arrow_forward
        </mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="action2">
      <th mat-header-cell *matHeaderCellDef>{{'DELETE'|translate}}</th>
      <td mat-cell *matCellDef="let view">
        <mat-icon style="color:red;cursor:pointer" (click)="deleteView(view.id)"
                  matTooltipPosition="right"
                  [matTooltip]="'DELETE'|translate">cancel
        </mat-icon>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="5"></mat-paginator>


  <div class="modal-footer">

    <button type="button" class="btn btn-light" (click)="activeModal.close('Close click')"
            [innerHTML]="'CLOSE' | translate">Close
    </button>
  </div>
</div>
